import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchAssignmentListAPI, deleteAssignmentAPI } from "./worksheetAPI";

const initialState = {
  results: [],
  current_page: 1,
  total_pages: 1,
  error: null,
};

export const fetchAssignments = createAsyncThunk(
  "worksheets/fetchAssignments",
  async (
    {
      page = 1,
      limit = 13,
      type = null,
      isFinished = null,
      keyword = null,
      levelId = null,
      studentId = null,
      studentGrade = null,
    },
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchAssignmentListAPI(
        page,
        limit,
        type,
        isFinished,
        levelId,
        keyword,
        studentId,
        studentGrade
      );
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const deleteAssignmentList = createAsyncThunk(
  "students/deleteAssignedWorksheetList",
  async ({ assignmentIds }, { rejectWithValue }) => {
    const successfulIds = [];
    const failedIds = [];

    await Promise.all(
      assignmentIds.map(async (assignmentId) => {
        try {
          await deleteAssignmentAPI(assignmentId);
          successfulIds.push(assignmentId); // 성공한 ID 추가
        } catch (error) {
          failedIds.push({
            assignmentId,
            error: error.response?.data || error.message, // 실패한 ID와 에러 메시지 저장
          });
        }
      })
    );

    return { successfulIds, failedIds };
  }
);

const assignmentListSlice = createSlice({
  name: "assignments",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAssignments.pending, (state) => {
        state.error = null;
      })
      .addCase(fetchAssignments.fulfilled, (state, action) => {
        const { results, current_page, total_pages } = action.payload;
        state.results = results;
        state.current_page = current_page;
        state.total_pages = total_pages;
      })
      .addCase(fetchAssignments.rejected, (state, action) => {
        state.error = action.payload || "Failed to fetch worksheets";
      })
      .addCase(deleteAssignmentList.pending, (state) => {
        state.error = null;
      })
      .addCase(deleteAssignmentList.fulfilled, (state, action) => {
        state.results = state.results.filter(
          (assignment) => !action.payload.successfulIds.includes(assignment.id) // 성공한 ID 제외
        );
      })
      .addCase(deleteAssignmentList.rejected, (state, action) => {
        state.error = action.error.message;
      });
  },
});

export default assignmentListSlice.reducer;
